export const COMPANIES = [
  {
    id: 'c0000001-0000-0000-0000-000000000001',
    name: 'PT Cendana Mitra Sejahtera',
    legal_name: 'PT Cendana Mitra Sejahtera',
    npwp: '01.234.567.8-901.000',
    nib: '0220011223344',
    industry: { id: 'ind-01', name: 'Financial Services' },
    business_category: { id: 'bc-01', name: 'Multi-Finance' },
    employee_range: { id: 'er-04', name: '500 - 1,000 employees' },
    address: 'Menara Cendana Lt. 21, Jl. Jend. Sudirman Kav. 35, Jakarta Selatan',
    province: 'DKI Jakarta',
    city: 'Jakarta Selatan',
    postal_code: '12190',
    phone: '+62 21 5210 8800',
    email: 'corporate@cendanamitra.co.id',
    website: 'https://cendanamitra.co.id',
    logo_url: null,
    enrollment_status: 'enrolled',
    enrollment_step: 4,
    is_active: true,
    contract_start_at: '2025-08-12T00:00:00Z',
    contract_end_at: '2027-08-11T00:00:00Z',
    created_at: '2025-08-01T03:21:00Z',
    updated_at: '2025-09-14T08:11:00Z',
  },
  {
    id: 'c0000002-0000-0000-0000-000000000002',
    name: 'PT Pratama Logistik Nusantara',
    legal_name: 'PT Pratama Logistik Nusantara Tbk',
    npwp: '02.345.678.9-012.000',
    nib: '0220022334455',
    industry: { id: 'ind-02', name: 'Logistics & Distribution' },
    business_category: { id: 'bc-02', name: 'Freight Forwarding' },
    employee_range: { id: 'er-05', name: '1,000 - 5,000 employees' },
    address: 'Wisma Pratama Lt. 8, Jl. HR Rasuna Said Blok X-1, Jakarta Selatan',
    province: 'DKI Jakarta',
    city: 'Jakarta Selatan',
    postal_code: '12940',
    phone: '+62 21 2553 1200',
    email: 'hr@pratamalogistik.com',
    website: 'https://pratamalogistik.com',
    logo_url: null,
    enrollment_status: 'enrolled',
    enrollment_step: 4,
    is_active: true,
    contract_start_at: '2025-06-20T00:00:00Z',
    contract_end_at: '2027-06-19T00:00:00Z',
    created_at: '2025-06-10T02:45:00Z',
    updated_at: '2026-04-02T03:25:00Z',
  },
  {
    id: 'c0000003-0000-0000-0000-000000000003',
    name: 'PT Adhikara Manufaktur Indonesia',
    legal_name: 'PT Adhikara Manufaktur Indonesia',
    npwp: '03.456.789.0-123.000',
    nib: '0220033445566',
    industry: { id: 'ind-03', name: 'Manufacturing' },
    business_category: { id: 'bc-03', name: 'Industrial Equipment' },
    employee_range: { id: 'er-03', name: '100 - 500 employees' },
    address: 'Kawasan Industri MM2100 Blok A-7, Cikarang Barat, Bekasi',
    province: 'Jawa Barat',
    city: 'Bekasi',
    postal_code: '17520',
    phone: '+62 21 8998 7700',
    email: 'people@adhikaramanufaktur.id',
    website: 'https://adhikaramanufaktur.id',
    logo_url: null,
    enrollment_status: 'enrolled',
    enrollment_step: 4,
    is_active: true,
    contract_start_at: '2025-10-04T00:00:00Z',
    contract_end_at: '2027-10-03T00:00:00Z',
    created_at: '2025-09-21T07:00:00Z',
    updated_at: '2026-02-18T09:48:00Z',
  },
  {
    id: 'c0000004-0000-0000-0000-000000000004',
    name: 'PT Nusantara Digital Karya',
    legal_name: 'PT Nusantara Digital Karya',
    npwp: '04.567.890.1-234.000',
    nib: '0220044556677',
    industry: { id: 'ind-04', name: 'Technology & Software' },
    business_category: { id: 'bc-04', name: 'Software-as-a-Service' },
    employee_range: { id: 'er-02', name: '50 - 100 employees' },
    address: 'SCBD Lot 14, Equity Tower Lt. 32, Jakarta Selatan',
    province: 'DKI Jakarta',
    city: 'Jakarta Selatan',
    postal_code: '12190',
    phone: '+62 21 2954 0900',
    email: 'people@nusantaradigital.co',
    website: 'https://nusantaradigital.co',
    logo_url: null,
    enrollment_status: 'enrolled',
    enrollment_step: 4,
    is_active: true,
    contract_start_at: '2026-01-16T00:00:00Z',
    contract_end_at: '2028-01-15T00:00:00Z',
    created_at: '2026-01-04T01:12:00Z',
    updated_at: '2026-04-22T06:30:00Z',
  },
  {
    id: 'c0000005-0000-0000-0000-000000000005',
    name: 'PT Wira Energi Hijau',
    legal_name: 'PT Wira Energi Hijau',
    npwp: '05.678.901.2-345.000',
    nib: '0220055667788',
    industry: { id: 'ind-05', name: 'Energy & Utilities' },
    business_category: { id: 'bc-05', name: 'Renewable Energy' },
    employee_range: { id: 'er-03', name: '100 - 500 employees' },
    address: 'Menara Hijau Lt. 12, Jl. MT Haryono Kav. 33, Jakarta Selatan',
    province: 'DKI Jakarta',
    city: 'Jakarta Selatan',
    postal_code: '12770',
    phone: '+62 21 7918 4400',
    email: 'recruitment@wiraenergi.id',
    website: 'https://wiraenergi.id',
    logo_url: null,
    enrollment_status: 'in_progress',
    enrollment_step: 3,
    is_active: false,
    contract_start_at: null,
    contract_end_at: null,
    created_at: '2026-04-10T04:10:00Z',
    updated_at: '2026-04-29T07:15:00Z',
  },
]

export const findCompany = (id) => COMPANIES.find((c) => c.id === id) ?? null
